import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { testimonials } from "@/data/testimonials";

const Stars = ({ className = "" }) => (
  <div className={`flex items-center gap-0.5 ${className}`}>
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="w-4 h-4 text-gavito-green fill-gavito-green" />
    ))}
  </div>
);

export const Testimonials = () => (
  <section data-testid="testimonials-section" className="pb-24 md:pb-32">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-gavito-green mb-4">Reference</p>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-gavito-navy leading-[1.05]">
            Co o nás říkají<br className="hidden md:block" /> naši absolventi
          </h2>
        </div>
        <a
          href="https://www.google.com/search?q=GAVITO+technic+recenze"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-rating-badge"
          className="inline-flex items-center gap-3 bg-white border border-gavito-navy/10 rounded-2xl px-5 py-4 hover:border-gavito-green transition-colors"
        >
          <span className="font-heading font-black text-3xl text-gavito-navy">5,0</span>
          <span>
            <Stars />
            <span className="block text-xs font-semibold text-gavito-navy/55 mt-1">Hodnocení na Google</span>
          </span>
        </a>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
        {testimonials.map((t, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            data-testid={`testimonial-card-${i}`}
            className="mb-6 break-inside-avoid bg-white border border-gavito-navy/10 rounded-3xl p-7"
          >
            <div className="flex items-center justify-between mb-4">
              <Stars />
              <Quote className="w-6 h-6 text-gavito-green/25" />
            </div>
            <blockquote className="text-gavito-navy/80 leading-relaxed">„{t.text}"</blockquote>
            <figcaption className="mt-5 pt-5 border-t border-gavito-navy/10">
              <p className="font-heading font-bold text-gavito-navy">{t.name}</p>
              <p className="text-sm text-gavito-navy/55">{t.role} · {t.context}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
